<template>
  <div class="menu-container">
    <div class="menu-header">
      <div class="menu-header-top">
        <div class="menu-header-account" @click="userNameHandler">
          <div class="header-account-text">{{ userName }}</div>
          <van-icon name="contact-o" size="24px" />
        </div>
      </div>
      <div id="menu-header-bottom">
        <div class="menu-header-title">
          <div class="menu-header-title-line1">{{ $t('view.popupMenu.browse') }}</div>
          <div class="menu-header-title-line2">{{ $t('view.popupMenu.trademark') }}</div>
        </div>
      </div>
    </div>
    <div class="menu-home-container" @click="returnHome">
      <div class="menu-title-text">{{ $t('view.popupMenu.homePage') }}</div>
      <div class="menu-home-right">
        <van-icon name="wap-home-o" size="22px" />
      </div>
    </div>
    <div class="menu-separator" />
    <div class="category-section">
      <div class="menu-title-text menu-title-padding">{{ $t('view.popupMenu.productCategory') }}</div>
      <!-- <div class="menu-mini-divider" /> -->
      <div v-for="menu in menuList" :key="menu.id" class="menu-item" @click="clickMenuItem(menu)">
        <div class="menu-item-text">{{ menu.value }}</div>
        <div v-if="menu.children && menu.children.length > 0" class="menu-item-right">
          <van-icon name="arrow" size="22px" color="#111" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupMainMenu',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      menuList: [],
      userName: this.$t('view.popupMenu.login') 
    }
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        this.menuList = newVal
      },
      deep: true
    }
  },
  created() {
    this.menuList = this.data
    this.getUserName()
  },
  methods: {
    userNameHandler(){
      this.$emit('click-user-name')
    },
    getUserName(){
      let uName = sessionStorage.getItem('user_nickname')
      if(uName !== null){
        this.userName = uName
      }
    },
    openUserInfoOrLogin() {
      if (sessionStorage.getItem('user_id') !== null && sessionStorage.getItem('user_id') !== '') {
        this.popupPosition = 'right'
        this.current = 'userInfo'
        this.showPopup = true
      } else {
        this.openLogin()
      }
    },
    returnHome() {
      this.$emit('return-home')
    },
    clickMenuItem(category) {
      this.$emit('menu-item-click', category)
    }
  }
}
</script>

<style scoped>
.menu-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
}

.menu-header {
  background-color: #232f3e;
  color: white;
  display: flex;
  flex-direction: column;
}

.menu-header-top {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.menu-header-account {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 20px 0 20px;
}

.header-account-text {
  padding-right: 4px;
  font-size: 14px;
  line-height: 14px;
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #fff;
}

.menu-header-bottom {
  flex-direction: column;
  justify-content: flex-end;
  display: flex;
}

.menu-header-title {
  flex-direction: column;
  justify-content: flex-end;
  color: #fff;
  padding: 0 20px 20px 20px;
}

.menu-header-title-line1 {
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
}

.menu-header-title-line2 {
  font-size: 28px;
  line-height: 28px;
}

.menu-home-container {
  justify-content: space-between;
  background-color: #fff;
  padding: 18px 20px 13px 20px;
  display: flex;
}

.menu-title-text {
  color: #111;
  font-size: 19px;
  line-height: 24px;
  font-weight: 700;
  text-transform: capitalize;
}

.menu-home-right {
  margin-left: 10px;
  justify-content: flex-end;
}

.menu-separator {
  border-bottom: 5px solid #d5dbdb;
  padding: 0;
  margin: 5px 0 0;
  display: block;
}

.category-section {
  height: auto;
  transition: height .4s cubic-bezier(.4, 0, .2, 1), opacity .4s cubic-bezier(.4, 0, .6, 1);
  padding: 15px 20px 15px 20px;
}

.menu-title-padding {
  padding: 0px 0px 15px 0px;
}

.menu-mini-divider {
  padding: 0;
  border-bottom: 1px solid #d5dbdb;
  margin: 5px 0px 5px 0px;
  display: block;
}

.menu-item {
  display: flex;
  padding: 15px 0px 15px 0px;
  justify-content: space-between;
  cursor: pointer;
}

.menu-item-text {
  text-decoration: none;
  color: #111;
}

.menu-item-right {
  margin-left: 10px;
  justify-content: flex-end;
}
</style>